import React from 'react';
import { IconProps } from './types';

const DiscountTagIcon = ({ className }: IconProps): React.ReactElement => (
  <svg
    className={`bundle-discount-tag-icon ${className}`}
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.944303 5L4.19553 0.75H15.25V9.25H4.19553L0.944303 5Z"
      stroke="#212B36"
      strokeWidth="1.5"
    />
    <circle cx="6" cy="5" r="1" fill="#212B36" />
  </svg>
);

export default DiscountTagIcon;
